import { LinkObject } from '../json-api.types';

export function getHrefFromLink(link: LinkObject) {
  return typeof link === 'string' ? link : link.href;
}
